import { connect } from 'amqplib';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var instance = null;
var RabbitMqPublisherService = /** @class */ (function () {
    function RabbitMqPublisherService(useSecureConnection, verbose, maxRetries, host, virtualHost, username, password) {
        if (useSecureConnection === void 0) { useSecureConnection = true; }
        if (verbose === void 0) { verbose = false; }
        if (maxRetries === void 0) { maxRetries = 5; }
        this.useSecureConnection = useSecureConnection;
        this.verbose = verbose;
        this.maxRetries = maxRetries;
        this.host = host;
        this.virtualHost = virtualHost;
        this.username = username;
        this.password = password;
    }
    RabbitMqPublisherService.getInstance = function (connectionInfo_1) {
        return __awaiter(this, arguments, void 0, function (connectionInfo, verbose) {
            if (verbose === void 0) { verbose = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!instance) return [3 /*break*/, 2];
                        instance = new RabbitMqPublisherService(true, verbose, 5, connectionInfo.host, connectionInfo.virtualHost, connectionInfo.username, connectionInfo.password);
                        return [4 /*yield*/, instance.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, instance];
                }
            });
        });
    };
    RabbitMqPublisherService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RabbitMqPublisherService.prototype.openConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, _a, _b, error_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        retryCount = 0;
                        _c.label = 1;
                    case 1:
                        if (!(retryCount < this.maxRetries)) return [3 /*break*/, 8];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, , 7]);
                        this.log("Connecting to ".concat(this.connectionUrlWithoutPwd));
                        _a = this;
                        return [4 /*yield*/, connect(this.connectionUrl, { heartbeat: 10 })];
                    case 3:
                        _a.connection = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.connection.createChannel()];
                    case 4:
                        _b.channel = _c.sent();
                        this.channel.on("close", function () {
                            _this.log("Channel closed. Attempting to reconnect...");
                            _this.reconnect();
                        });
                        this.log("Connected and channel created.");
                        return [3 /*break*/, 8];
                    case 5:
                        error_1 = _c.sent();
                        this.logError("Connection attempt failed (".concat(retryCount + 1, "/").concat(this.maxRetries, ")"), error_1);
                        if (retryCount === this.maxRetries - 1)
                            throw new Error("Unable to connect after ".concat(this.maxRetries, " attempts."));
                        return [4 /*yield*/, this.delay(2000)];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        retryCount++;
                        return [3 /*break*/, 1];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RabbitMqPublisherService.prototype.reconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.log("Reconnecting...");
                        return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.logError("Reconnection failed", error_2);
                        setTimeout(function () { return _this.reconnect(); }, 5000);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RabbitMqPublisherService.prototype.sendEvent = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.connection) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.sendMessageWithRetry(message)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RabbitMqPublisherService.prototype.sendMessageWithRetry = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var body, headers, retryCount, status_1, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = Buffer.from(JSON.stringify(message.body), "utf-8");
                        headers = {
                            Id: message.id,
                            Name: message.name,
                            Sender: message.sender,
                            Timestamp: message.sentTimestamp
                                ? message.sentTimestamp
                                : new Date().toISOString(),
                            Type: message.type,
                            Version: message.version,
                            IsTest: "False",
                            Topic: message.topic,
                        };
                        retryCount = 0;
                        _a.label = 1;
                    case 1:
                        if (!(retryCount < this.maxRetries)) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 3, , 5]);
                        status_1 = this.channel.publish(message.exchange, message.routingKey, body, { headers: headers });
                        this.log("Message publish status: ".concat(status_1));
                        return [3 /*break*/, 6];
                    case 3:
                        error_3 = _a.sent();
                        this.logError("Failed to send message (".concat(retryCount + 1, "/").concat(this.maxRetries, ")"), error_3);
                        if (retryCount === this.maxRetries - 1)
                            throw new Error("Unable to send message after ".concat(this.maxRetries, " attempts."));
                        return [4 /*yield*/, this.delay(500)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        retryCount++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RabbitMqPublisherService.prototype, "connectionProtocol", {
        get: function () {
            return this.useSecureConnection ? "amqps" : "amqp";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RabbitMqPublisherService.prototype, "connectionUrl", {
        get: function () {
            return "".concat(this.connectionProtocol, "://").concat(this.username, ":").concat(this.password, "@").concat(this.host, "/").concat(this.virtualHost);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RabbitMqPublisherService.prototype, "connectionUrlWithoutPwd", {
        get: function () {
            return "".concat(this.connectionProtocol, "://").concat(this.username, ":******@").concat(this.host, "/").concat(this.virtualHost);
        },
        enumerable: false,
        configurable: true
    });
    RabbitMqPublisherService.prototype.log = function (message) {
        if (this.verbose)
            console.log("RabbitMqService: ".concat(message));
    };
    RabbitMqPublisherService.prototype.logError = function (message, error) {
        if (this.verbose)
            console.error("RabbitMqService: ".concat(message), error);
    };
    RabbitMqPublisherService.prototype.delay = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    return RabbitMqPublisherService;
}());

export { RabbitMqPublisherService };
//# sourceMappingURL=index.js.map
